import {BreadcrumbName} from 'common/src/modules/breadcrumbs/breadcrumbs.enums';
import createCreativeFromTemplateTool from 'common/src/modules/creatives/copilot/agents/creativesManagerAgent/tools/createCreativeFromTemplateTool';
import filterCreativesLibraryTool from 'common/src/modules/creatives/copilot/agents/creativesManagerAgent/tools/filterCreativesLibraryTool';
import getCreativeInfoTool from 'common/src/modules/creatives/copilot/agents/creativesManagerAgent/tools/getCreativeInfoTool';
import getCreativesIdsByNameTool from 'common/src/modules/creatives/copilot/agents/creativesManagerAgent/tools/getCreativesIdsByNameTool';
import navigateToCreativePageTool from 'common/src/modules/creatives/copilot/agents/creativesManagerAgent/tools/navigateToCreativePageTool';
import showCreativePreviewTool from 'common/src/modules/creatives/copilot/agents/creativesManagerAgent/tools/showCreativePreviewTool';
import {EntityTypeToRename} from 'common/src/modules/shared/copilot/copilot.enums';
import batchRenameEntitiesTool from 'common/src/modules/shared/copilot/tools/batchRenameEntitiesTool';
import {SkillName} from 'common/src/modules/shared/copilot/skills/skills.enums';
import skill from 'common/src/modules/shared/copilot/utils/creators/skill';
import {CLStore} from 'common/src/redux/store';

function creativesManagerSkill(store: CLStore) {
  return skill({
    name: SkillName.CreativesManager,
    description:
      'Manages creatives — find, navigate, preview, create from template, and rename creatives',
    whenToUse:
      'Finding, navigating, and managing creatives (published ad instances). Handles looking up creatives by name, navigating to creative pages, previewing creative content, creating new creatives from existing templates, filtering the creatives library, and batch renaming creatives.',
    whenToAvoid:
      'Analytics or performance data about creatives such as impressions, clicks, CTR, or top/worst performing creatives. Editing template layers or managing creative templates.',
    instructions:
      'Help the user manage creatives. You can find creatives by name, navigate to creative pages, preview creatives, create new creatives from templates, filter the creatives library, and rename creatives in bulk.',
    tools: [
      // navigateToCreativesLibraryTool(store),
      navigateToCreativePageTool(),
      getCreativesIdsByNameTool(),
      getCreativeInfoTool(store),
      showCreativePreviewTool(store),
      filterCreativesLibraryTool(store),
      createCreativeFromTemplateTool(),
      batchRenameEntitiesTool({
        entityType: EntityTypeToRename.Creative,
        toolName: 'batchRenameCreatives',
      }),
    ],
    applicableBreadcrumbs: [BreadcrumbName.CreativesLibrary, BreadcrumbName.CreativePage],
  });
}

export default creativesManagerSkill;
